export const getLanguageFromUrl = (): string => {
  return window.location?.href?.includes('/en') ? 'en' : 'fr';
};
